<template>
  <WdsSelect
    v-model="state"
    can-deselect
    :list="options"
    :label="meta?.filter?.quickFilter ? '' : $t('Worker type')"
    :placeholder="$t('Any worker type')"
    class="tw-min-w-[150px]"
    data-test="tc-filter-worker-type"
    labels-primary
  />
</template>

<script setup lang="ts">
import { WdsSelect } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { TrustedContactManagedStatus } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

const { meta } = defineProps<{ meta?: FilterMetaDataProp }>()

type Option = { label: string; value: TrustedContactManagedStatus }

const selected: ModelRef<TrustedContactManagedStatus | null> = defineModel({
  default: () => null,
})

const options: Option[] = [
  { label: $t('Managed (by supplier)'), value: TrustedContactManagedStatus.StaffingAgency },
  { label: $t('Worker account (direct)'), value: TrustedContactManagedStatus.Worker },
  { label: $t('Unclaimed'), value: TrustedContactManagedStatus.Unmanaged },
]

const state = computed<Option | null>({
  get() {
    if (!selected.value) return null
    return options.find((opt) => opt.value === selected.value) ?? null
  },
  set(option: Option | null) {
    selected.value = option?.value ?? null
  },
})
</script>
